export const commonFormControl = {
  maxWidth: 464,
  height: 32,
  fontSize: 14,
  lineSpacing: 16,
};
